<template>
  <div>
  </div>
</template>

<script>
import svgAsset from '@/assets/DisplayX19320.svg';
// import logger from '@/logger';
import state from '@/state';

const segments = [
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  'symbol46',
  'symbol47',
  'symbol45',
  null,
  null,
  null,
  null,
  'segment5d2',
  'segment5b',
  'segment5c',
  'segment5a2',
  'symbol51',
  'symbol49',
  'symbol50',
  'symbol48',
  'segment5n',
  'segment5g',
  'segment5o',
  'segment5h',
  'segment5m',
  'segment5k',
  'segment5l',
  'segment5i',
  'segment4d2',
  'segment4b',
  'segment4c',
  'segment4a2',
  'segment5d1',
  'segment5f',
  'segment5e',
  'segment5a1',
  'segment4n',
  'segment4g',
  'segment4o',
  'segment4h',
  'segment4m',
  'segment4k',
  'segment4l',
  'segment4i',
  'segment3d2',
  'segment3b',
  'segment3c',
  'segment3a2',
  'segment4d1',
  'segment4f',
  'segment4e',
  'segment4a1',
  'segment3n',
  'segment3g',
  'segment3o',
  'segment3h',
  'segment3m',
  'segment3k',
  'segment3l',
  'segment3i',
  'segment2d2',
  'segment2b',
  'segment2c',
  'segment2a2',
  'segment3d1',
  'segment3f',
  'segment3e',
  'segment3a1',
  'segment2n',
  'segment2g',
  'segment2o',
  'segment2h',
  'segment2m',
  'segment2k',
  'segment2l',
  'segment2i',
  'segment1d2',
  'segment1b',
  'segment1c',
  'segment1a2',
  'segment2d1',
  'segment2f',
  'segment2e',
  'segment2a1',
  'segment1n',
  'segment1g',
  'segment1o',
  'segment1h',
  'segment1m',
  'segment1k',
  'segment1l',
  'segment1i',
  'symbol42',
  'symbol26',
  null,
  'symbol27',
  'segment1d1',
  'segment1f',
  'segment1e',
  'segment1a1',
  'symbol24',
  'symbol22',
  'symbol40',
  'symbol25',
  'symbol23',
  'symbol33',
  'symbol16',
  'symbol15',
  'symbol61',
  'symbol34',
  'symbol39',
  'symbol17',
  'symbol44',
  'symbol18',
  'symbol19',
  'symbol21',
  null,
  'symbol13',
  'symbol31',
  'symbol12',
  null,
  'symbol38',
  'symbol37',
  'symbol43',
  'symbol1',
  'symbol2',
  'symbol5',
  'symbol14',
  'symbol3',
  null,
  'symbol4',
  null,
  null,
  null,
  'symbol8',
  'symbol10',
  'symbol6',
  'symbol9',
  'symbol7',
  'symbol11',
  'symbol29',
  null,
  'symbol30',
  null,
  'symbol35',
  'symbol20',
  null,
  'symbol32',
  'segment6a1',
  'segment6e',
  'segment6f',
  'segment6d1',
  'symbol28',
  'symbol41',
  'symbol36',
  'symbol52',
  'segment6i',
  'segment6l',
  'segment6k',
  'segment6m',
  'segment6h',
  'segment6o',
  'segment6g',
  'segment6n',
  'segment7a1',
  'segment7e',
  'segment7f',
  'segment7d1',
  'segment6a2',
  'segment6c',
  'segment6b',
  'segment6d2',
  'segment7i',
  'segment7l',
  'segment7k',
  'segment7m',
  'segment7h',
  'segment7o',
  'segment7g',
  'segment7n',
  null,
  'dp',
  null,
  'p7',
  'segment7a2',
  'segment7c',
  'segment7b',
  'segment7d2',
  'segment8h',
  'segment8o',
  'segment8g',
  'segment8n',
  'segment8a1',
  'segment8e',
  'segment8f',
  'segment8d1',
  'segment8a2',
  'segment8c',
  'segment8b',
  'segment8d2',
  'segment8i',
  'segment8l',
  'segment8k',
  'segment8m',
  'segment9a1',
  'segment9e',
  'segment9f',
  'segment9d1',
  null,
  'p8',
  null,
  'symbol57',
  'segment9i',
  'segment9l',
  'segment9k',
  'segment9m',
  'segment9h',
  'segment9o',
  'segment9g',
  'segment9n',
  'symbol53',
  'symbol55',
  'symbol54',
  'symbol56',
  'segment9a2',
  'segment9c',
  'segment9b',
  'segment9d2',
];

export default {
  props: [
    'bridge',
    'displayBuffer',
  ],

  watch: {
    displayBuffer() {
      const activeClass = 'rs-x19320-active';
      const inactiveClass = 'rs-x19320-inactive';

      for (let i = 0; i < segments.length; i++) {
        const segment = segments [i];
        if (segment) {
          const offset = i >> 3;
          const mask = 1 << (i & 7);
          const state = !!(this.displayBuffer [offset] & mask);
          const elements = this.$el.querySelectorAll(`.rs-x19320-${segment}`);
          for (const element of elements) {
            if (state) {
              if (element.classList.contains(inactiveClass)) {
                element.classList.remove(inactiveClass);
              }
              if (!element.classList.contains(activeClass)) {
                element.classList.add(activeClass);
              }
            } else {
              if (element.classList.contains(activeClass)) {
                element.classList.remove(activeClass);
              }
              if (!element.classList.contains(inactiveClass)) {
                element.classList.add(inactiveClass);
              }
            }
          }
        }
      }
    }
  },

  methods: {
    getDisplaySvg() {
      return this.$el.innerHTML;
    },
  },

  mounted() {
    state.runAsync(async () => {
      const httpResponse = await fetch(svgAsset);
      if (!httpResponse.ok) {
        throw new Error('Unable to fetch display SVG');
      }

      const svgString = await httpResponse.text();

      this.$el.innerHTML = svgString;

      const svgEl = this.$el.querySelector('svg');
      // svgEl.setAttribute('viewBox', '70.7 85.4 71.7 38.6');
      svgEl.setAttribute('width', '100%');
      svgEl.setAttribute('height', '100%');

      // for testing purposes only
      // console.log(segments.length);
      // for (const segment of segments) {
      //   if (segment) {
      //     const elems = svgEl.querySelectorAll(`.rs-x19320-${segment}`);
      //     if (elems.length === 0) {
      //       throw new Error(`Unknown segment ${segment}`);
      //     }
      //   }
      // }
    });
  }
};
</script>

<style>

</style>
